import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/button'
import Container from '@/components/base/container'
import FluidSpacer from '@/components/base/fluid-spacer'
import Form from '@/components/base/form'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import SVGIcon from '@/components/base/svg-icon'
import TextEffect from '@/components/base/text-effect'
import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type LeadGenerationProps = HTMLAttributes<HTMLDivElement> & {
  showTopFluidSpacer: boolean
}

const LeadGeneration = ({
  className,
  showTopFluidSpacer,
  ...props
}: LeadGenerationProps) => {
  const { strings } = useStore()
  return (
    <>
      {showTopFluidSpacer ? <FluidSpacer variant="top" /> : null}

      <Section className={cn('dark relative', className)} {...props}>
        <Container className="py-s-spacer-xl md:py-d-spacer-xl">
          <Grid className="gap-y-spacing-lg">
            <div
              className={cn(
                'col-span-2 md:col-span-3 lg:col-span-6',
                'grid gap-y-spacing-sm'
              )}
            >
              <div className="flex flex-col gap-y-spacing-sm">
                {strings?.lead_generation?.contacts?.pretitle ? (
                  <Typography
                    variant="overline"
                    paragraph
                    className="uppercase"
                  >
                    {strings.lead_generation.contacts.pretitle}
                  </Typography>
                ) : null}

                {strings?.lead_generation?.contacts?.title ? (
                  <Typography variant="h4" component="h2">
                    {strings.lead_generation.contacts.title}
                  </Typography>
                ) : null}

                {strings?.lead_generation?.contacts?.paragraph ? (
                  <Typography variant="regular" paragraph>
                    {strings.lead_generation.contacts.paragraph}
                  </Typography>
                ) : null}
              </div>

              <SVGIcon
                symbol="message-icon"
                className="h-[5.1rem] w-[6rem] fill-surface-accent-invert-dark dark:fill-surface-accent-invert-light"
              />

              {strings?.lead_generation?.contacts?.button &&
              strings?.lead_generation?.contacts?.button?.url ? (
                <div>
                  <Button isLiquid asChild variant="secondary" isInverted>
                    <Link
                      href={strings.lead_generation.contacts.button.url}
                      target={strings.lead_generation.contacts.button.target}
                      scroll={false}
                    >
                      <TextEffect>
                        <Typography variant="regular">
                          {strings.lead_generation.contacts.button.title}
                        </Typography>
                      </TextEffect>
                    </Link>
                  </Button>
                </div>
              ) : null}
            </div>

            <div
              className={cn(
                'col-span-2 md:col-span-3 lg:col-span-6',
                'grid gap-y-spacing-sm'
              )}
            >
              {/* <div className="flex flex-col gap-y-spacing-sm">
                {strings?.lead_generation?.newsletter?.pretitle ? (
                  <Typography
                    variant="overline"
                    paragraph
                    className="uppercase"
                  >
                    {strings.lead_generation.newsletter.pretitle}
                  </Typography>
                ) : null}

                {strings?.lead_generation?.newsletter?.title ? (
                  <Typography variant="h4" component="h2">
                    {strings.lead_generation.newsletter.title}
                  </Typography>
                ) : null}

                {strings?.lead_generation?.newsletter?.paragraph ? (
                  <Typography variant="regular" paragraph>
                    {strings.lead_generation.newsletter.paragraph}
                  </Typography>
                ) : null}

                {strings?.lead_generation?.newsletter?.form?.id ? (
                  <Form
                    form_id={strings.lead_generation.newsletter.form.id}
                    fields={strings.lead_generation.newsletter.form.fields}
                    submit={strings.lead_generation.newsletter.form.button.text}
                    theme="dark"
                  />
                ) : null}
              </div> */}
            </div>
          </Grid>
        </Container>
      </Section>
    </>
  )
}

export default LeadGeneration
